const loadUntilProjectionAdvances = async ({ getItemCount, loadPage }) => {
  const beforeCount = getItemCount()
  let afterCount = beforeCount
  let loaded = false
  let pageCount = 0

  while (afterCount === beforeCount) {
    const page = await loadPage()
    if (!Array.isArray(page) || page.length === 0) break
    loaded = true
    pageCount += 1
    afterCount = getItemCount()
  }

  return {
    beforeCount,
    afterCount,
    count: Math.max(0, afterCount - beforeCount),
    loaded,
    pageCount
  }
}

module.exports = {
  loadUntilProjectionAdvances
}
